export default __webpack_public_path__ + "static/media/Manrope-SemiBold.33d2f89e.ttf";